import { render, staticRenderFns } from "./BusinessPartnerAddressForm.vue?vue&type=template&id=ba8a800e&"
import script from "./BusinessPartnerAddressForm.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerAddressForm.vue?vue&type=style&index=0&id=ba8a800e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports